export default {"src":"/statics/ecommerce/_next/static/media/logo-recommerce.81e2f093.svg","height":26,"width":201,"blurWidth":0,"blurHeight":0};